import { Box } from '@mui/material'
import React from 'react'
import InvoicesContainer from '../../containers/InvoicesContainer'

export default function Invoices() {
  return (
    <Box>
      <InvoicesContainer />
    </Box>
  )
}
